import { BiBible } from 'react-icons/bi'
import { BiBook } from 'react-icons/bi'
import { FaCoins } from 'react-icons/fa'
import { Plus, Minus } from 'lucide-react'
import { BsPersonFill } from 'react-icons/bs'
import "./aulaLista.css"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { filtro,getDocumentoUnico,updateItem, atualizarListaDeAlunos, getItens, buscarProfessores } from "../../../firebase/CRUD"
import {  FichaAlunoChamada } from "../../layout/Fichas"
import { useAuth } from '../../../hooks/AuthContext'
import Input from '../../layout/Input/Input'
import { useToast } from '../../../hooks/Toast'
import CardsChamada from './CardsChamada'
import Button from '../../layout/Button/Button'

export const PopUpPonto = ({value = 0,change,salvar,fechar})=>{
    console.log(value)
    return(
        <div className={'pontosContainer'}>
            <div className={'popPontos'}>
                <div><p></p><p onClick={fechar} style={{fontSize:'20px'}}>X</p></div>
                <div style={{flexDirection:'row'}}>
                    <Minus size={25} onClick={()=>{change(-1)}}/>
                        <p>{value}</p>
                    <Plus size={25} onClick={()=>{change(+1)}}/>
                </div>
                <Button onClick={salvar}>
                    Pontuar
                </Button>
            </div>
        </div>
    )
}

export default function AulaChamada(){
    const {mostrarAviso} = useToast()
    const [AlunosTurma,setAlunosTurma] = useState([])
    const [totBiblia, setTotBiblia] = useState(0)
    const [totRevista, setTotRevista] = useState(0)
    const [totOferta, setTotOferta] = useState(0)
    const [totPresenca,setTotPresenca] = useState(0)
    const [visitantes,setVisitantes] = useState(0)
    const [click,setClick] = useState(false)
    const [aula,setAula] = useState()
    const [professores,setProfessores] = useState()
    const [ponto,setPonto] = useState(false)
    const [pontoAluno, setPontoAluno] = useState({
        index: -1,
        ponto:0
    })
    
    const navigate = useNavigate()
    const {id} = useParams()
    const {usuario} = useAuth()

    useEffect(()=>{
        const listaAlunos = (doc)=>{
            if(!doc.listaAlunos){
                buscarProfessores(setProfessores,usuario.idEscola,doc.idTurma)
                if(doc.nome != "Professores"){
                    filtro("alunos","turma","==",doc.idTurma,setAlunosTurma,usuario.idEscola)
                    
                }
                else {
                    getItens('professores',setAlunosTurma,usuario.idEscola)
                }
            }else {
                setTotOferta(doc.totalOfertas)
                setTotBiblia(doc.biblias)
                setTotRevista(doc.revistas)
                setTotPresenca(doc.presencas)
                setVisitantes(doc.visitantes)
                setAlunosTurma(doc.listaAlunos)
            }
            setAula(doc)
        }
        if(usuario)
            getDocumentoUnico("aulaTurma",id,listaAlunos,usuario.idEscola)
    },[usuario])

    const atualizar = async (colecao,documento,objeto,idEscola)=>{
       await updateItem(
            colecao,
            documento,
            objeto,
            idEscola
        )

        mostrarAviso('Chamada enviada','sucesso')
        // navigate(-1,{replace:true})
    }
    const atualizarAlunos = ()=>{
       
        let trimestre = aula.data.trimestre - 1
        AlunosTurma.forEach((item)=>{
            if(item.biblia){
                item.biblia = false
                item.historico.biblias[trimestre] += 1
            }
             if(item.revista){
                item.revista = false
                item.historico.revistas[trimestre] += 1
            }
            if(item.presencas){
                item.presencas = false
                item.historico.presencas[trimestre] += 1
            }
            if(item.oferta){
                item.oferta = false
            }
            if(item.pontos > 0){
                item.historico.pontos[trimestre] += item.pontos
                item.pontos = 0
            }
        })
        let collectionName = (aula.nome == "Professores" ? "professores":"alunos")
        atualizarListaDeAlunos(collectionName,AlunosTurma,usuario.idEscola)
        navigate(-1,{replace:true})
    }
   const contar = ()=>{
        let totBib = 0
        let totRev = 0
        let totPres = 0
        AlunosTurma.forEach((element)=>{
            console.log(element)
            if(element.pontos > 0){
                element.presencas = true
            }
            if(element.biblia) 
                totBib++
            if(element.revista)
                totRev++
            if(element.presencas)
                totPres++
        })
        setTotBiblia(totBib)
        setTotRevista(totRev)
        setTotPresenca(totPres)
   }
    const marcarBiblia = (index)=>{
        AlunosTurma[index].biblia = !AlunosTurma[index].biblia 
        AlunosTurma[index].pontos += (AlunosTurma[index].biblia ? 2:-2)
        console.log((AlunosTurma[index].biblia ? 2:-2))
        contar()
    }
    const marcarRevista = (index)=>{
        AlunosTurma[index].revista = !AlunosTurma[index].revista 
        AlunosTurma[index].pontos += (AlunosTurma[index].revista ? 2:-2)
        contar()
    }
     const marcarPresenca = (index)=>{
        AlunosTurma[index].presencas = !AlunosTurma[index].presencas
        AlunosTurma[index].pontos += (AlunosTurma[index].presencas ? 2:-2)
        contar()
    }
    const marcarOferta = (index)=>{
        AlunosTurma[index].oferta = !AlunosTurma[index].oferta 
        AlunosTurma[index].pontos += (AlunosTurma[index].oferta ? 2:-2)
        setClick(!click)
    }
    const alterarPonto = (e)=>{
        setPontoAluno(
           { 
                ...pontoAluno,
                ponto: pontoAluno.ponto + e
            })
    }
    const ativarPonuador = (index)=>{
        if(ponto){
            setPontoAluno({
                index: -1,
                ponto: 0
            })
        }
        let pontos = 0
        if(AlunosTurma[index].biblia ){
            pontos += 2
        }
        if(AlunosTurma[index].revista ){
            pontos += 2
        }
        if(AlunosTurma[index].presenca ){
            pontos += 1
        }
        if(AlunosTurma[index].oferta ){
            pontos += 2
        }
        setPontoAluno({
            index: index,
            ponto: pontos
        })
        setPonto(true)
    }
    const marcarPonto = ()=>{
        AlunosTurma[pontoAluno.index].pontos = pontoAluno.ponto
        setPontoAluno({ index: -1,
        ponto:0})
        setPonto(false)
    }
    const fecharPonto = ()=>{
        setPontoAluno({ index: -1,
        ponto:0})
        setPonto(false)
    }
    const mudancaEstadoVisitantes = (e)=>{
        console.log(e.target.value)
        
        setVisitantes(Number(e.target.value))
    }
     const mudancaEstadoOferta = (e)=>{
        setTotOferta(Number(e.target.value))
    }
    
    return(
        <div className='container'>
            <div style={{width: "100%"}}>
                <h2>Alunos</h2>
            </div>
            {ponto && <PopUpPonto value={pontoAluno.ponto} change={alterarPonto} salvar={marcarPonto} fechar={fecharPonto}/>}
            {AlunosTurma.length > 0 && 
                AlunosTurma.map((item,id)=>
                    <CardsChamada
                        key={id}
                        id={id}   
                        nome={item.nome}
                        marcarBiblia={marcarBiblia}
                        marcarRevista={marcarRevista}
                        marcarOferta={marcarOferta}
                        marcarPonto={ativarPonuador}
                        marcarPresenca={marcarPresenca}
                        presenca={item.presencas}
                        oferta={item.oferta}
                        biblia={item.biblia}
                        revista={item.revista}
                        pontos={item.pontos}
                    />
                )
            } 
            <div className='inputsNum'>
                <Input label={"Visitantes"} type='number' placeholder={0} onChange={mudancaEstadoVisitantes} name={'visitantes'} value={visitantes}/>
               
                <Input label={"Oferta"} type='number' placeholder={0} onChange={mudancaEstadoOferta} name={'totOferta'} value={totOferta}/>
               
            </div>
            <h3 className='resumoTitulo'>Resumo</h3>
            <div className='resumoTurma'>
                
                <div>
                    <p>Total de Bíblias</p>
                    <p>{totBiblia} <BiBible size={20} color='brown'/></p>
                </div>
                <div>
                    <p>Total de Revistas</p>
                    <p>{totRevista} <BiBook size={20} color='blue'/></p>
                </div>
                <div>
                    <p>Total de Ofertas</p>
                    <p>{totOferta} <FaCoins size={20} color='orange'/></p>
                </div>
                <div>
                    <p>Presentes</p>
                    <p>{totPresenca} <BsPersonFill size={20} color='black'/></p>
                </div>
                <div>
                    <p>Visitantes</p>
                    <p>{visitantes} <BsPersonFill size={20} color='black'/></p>
                </div>
            </div>
            
            {aula && 
            aula.situacao == "aberta" ? (<Button onClick={()=>{
                    if(AlunosTurma.length > 0){
                        let alunos = []
                        AlunosTurma.forEach((item)=>{
                            alunos.push(item)
                        })
                        console.log(aula)
                        let turmaAula = {
                            matriculados: AlunosTurma.length,
                            ausentes: AlunosTurma.length - totPresenca,
                            totalGeral: totPresenca + visitantes,
                            totalOfertas: totOferta,
                            percentual: Number((100*totPresenca)/AlunosTurma.length),
                            listaAlunos: alunos,
                            visitantes: visitantes,
                            situacao: "fechada",
                            nome: aula.nome,
                            biblias: totBiblia,
                            revistas: totRevista,
                            presencas: totPresenca,
                            professores:professores,
                        }
                        console.log(turmaAula)
                        atualizar("aulaTurma",id,turmaAula,usuario.idEscola)

                        atualizarAlunos()
                        }
                    }}>
                    Enviar Relatório
                </Button>):
                (<Button onClick={()=>{
                        if(usuario.perfil == 'adm'){
                                navigate(-1)
                        }
                        if(usuario.perfil == 'professor'){
                            navigate('/',{replace:true})
                        }
                    }}>
                    Voltar
                </Button>)
            }
        </div>
    )
}